// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/usage.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { RunnerKind } from "./runner_configuration_pb.js";

/**
 * Resolution specifies the time granularity for time series data.
 *
 * @generated from enum gitpod.v1.Resolution
 */
export enum Resolution {
  /**
   * @generated from enum value: RESOLUTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOLUTION_HOURLY = 1;
   */
  HOURLY = 1,

  /**
   * @generated from enum value: RESOLUTION_DAILY = 2;
   */
  DAILY = 2,

  /**
   * @generated from enum value: RESOLUTION_WEEKLY = 3;
   */
  WEEKLY = 3,

  /**
   * @generated from enum value: RESOLUTION_MONTHLY = 4;
   */
  MONTHLY = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(Resolution)
proto3.util.setEnumType(Resolution, "gitpod.v1.Resolution", [
  { no: 0, name: "RESOLUTION_UNSPECIFIED" },
  { no: 1, name: "RESOLUTION_HOURLY" },
  { no: 2, name: "RESOLUTION_DAILY" },
  { no: 3, name: "RESOLUTION_WEEKLY" },
  { no: 4, name: "RESOLUTION_MONTHLY" },
]);

/**
 * DateRange specifies a time period for queries.
 *
 * @generated from message gitpod.v1.DateRange
 */
export class DateRange extends Message<DateRange> {
  /**
   * Start time of the date range (inclusive).
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * End time of the date range (exclusive).
   *
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  constructor(data?: PartialMessage<DateRange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DateRange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DateRange {
    return new DateRange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJsonString(jsonString, options);
  }

  static equals(a: DateRange | PlainMessage<DateRange> | undefined, b: DateRange | PlainMessage<DateRange> | undefined): boolean {
    return proto3.util.equals(DateRange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.TimeSeriesPoint
 */
export class TimeSeriesPoint extends Message<TimeSeriesPoint> {
  /**
   * Timestamp for this data point.
   *
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * The numerical value for this data point.
   *
   * @generated from field: int32 value = 2;
   */
  value = 0;

  constructor(data?: PartialMessage<TimeSeriesPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.TimeSeriesPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromJsonString(jsonString, options);
  }

  static equals(a: TimeSeriesPoint | PlainMessage<TimeSeriesPoint> | undefined, b: TimeSeriesPoint | PlainMessage<TimeSeriesPoint> | undefined): boolean {
    return proto3.util.equals(TimeSeriesPoint, a, b);
  }
}

/**
 * EnvironmentUsageRecord represents a record of an environment from start to stop.
 *
 * @generated from message gitpod.v1.EnvironmentUsageRecord
 */
export class EnvironmentUsageRecord extends Message<EnvironmentUsageRecord> {
  /**
   * Environment usage record ID.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Environment ID associated with the record.
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  /**
   * User ID is the ID of the user who created the environment associated with the record.
   *
   * @generated from field: string user_id = 3;
   */
  userId = "";

  /**
   * Project ID associated with the environment (if available).
   *
   * @generated from field: string project_id = 4;
   */
  projectId = "";

  /**
   * Runner ID associated with the environment.
   *
   * @generated from field: string runner_id = 5;
   */
  runnerId = "";

  /**
   * Environment class ID associated with the record.
   *
   * @generated from field: string environment_class_id = 6;
   */
  environmentClassId = "";

  /**
   * Time when the environment was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Time when the environment was stopped.
   *
   * @generated from field: google.protobuf.Timestamp stopped_at = 8;
   */
  stoppedAt?: Timestamp;

  constructor(data?: PartialMessage<EnvironmentUsageRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EnvironmentUsageRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "stopped_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnvironmentUsageRecord {
    return new EnvironmentUsageRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnvironmentUsageRecord {
    return new EnvironmentUsageRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnvironmentUsageRecord {
    return new EnvironmentUsageRecord().fromJsonString(jsonString, options);
  }

  static equals(a: EnvironmentUsageRecord | PlainMessage<EnvironmentUsageRecord> | undefined, b: EnvironmentUsageRecord | PlainMessage<EnvironmentUsageRecord> | undefined): boolean {
    return proto3.util.equals(EnvironmentUsageRecord, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersCountRequest
 */
export class GetActiveUsersCountRequest extends Message<GetActiveUsersCountRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetActiveUsersCountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersCountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersCountRequest {
    return new GetActiveUsersCountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersCountRequest {
    return new GetActiveUsersCountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersCountRequest {
    return new GetActiveUsersCountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersCountRequest | PlainMessage<GetActiveUsersCountRequest> | undefined, b: GetActiveUsersCountRequest | PlainMessage<GetActiveUsersCountRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersCountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersCountResponse
 */
export class GetActiveUsersCountResponse extends Message<GetActiveUsersCountResponse> {
  /**
   * Count of active users in the date range.
   *
   * @generated from field: int64 count = 1;
   */
  count = protoInt64.zero;

  /**
   * Trend of active users compared to the previous date_range in %. Calculated as (current - previous) / previous.
   *
   * @generated from field: double trend = 2;
   */
  trend = 0;

  constructor(data?: PartialMessage<GetActiveUsersCountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersCountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersCountResponse {
    return new GetActiveUsersCountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersCountResponse {
    return new GetActiveUsersCountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersCountResponse {
    return new GetActiveUsersCountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersCountResponse | PlainMessage<GetActiveUsersCountResponse> | undefined, b: GetActiveUsersCountResponse | PlainMessage<GetActiveUsersCountResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersCountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopActiveUsersRequest
 */
export class GetTopActiveUsersRequest extends Message<GetTopActiveUsersRequest> {
  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<GetTopActiveUsersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopActiveUsersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopActiveUsersRequest {
    return new GetTopActiveUsersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopActiveUsersRequest {
    return new GetTopActiveUsersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopActiveUsersRequest {
    return new GetTopActiveUsersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopActiveUsersRequest | PlainMessage<GetTopActiveUsersRequest> | undefined, b: GetTopActiveUsersRequest | PlainMessage<GetTopActiveUsersRequest> | undefined): boolean {
    return proto3.util.equals(GetTopActiveUsersRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopActiveUsersResponse
 */
export class GetTopActiveUsersResponse extends Message<GetTopActiveUsersResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * List of users sorted by total runtime (descending).
   *
   * @generated from field: repeated gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo users = 2;
   */
  users: GetTopActiveUsersResponse_UserRuntimeInfo[] = [];

  constructor(data?: PartialMessage<GetTopActiveUsersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopActiveUsersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "users", kind: "message", T: GetTopActiveUsersResponse_UserRuntimeInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopActiveUsersResponse {
    return new GetTopActiveUsersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse {
    return new GetTopActiveUsersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse {
    return new GetTopActiveUsersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopActiveUsersResponse | PlainMessage<GetTopActiveUsersResponse> | undefined, b: GetTopActiveUsersResponse | PlainMessage<GetTopActiveUsersResponse> | undefined): boolean {
    return proto3.util.equals(GetTopActiveUsersResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo
 */
export class GetTopActiveUsersResponse_UserRuntimeInfo extends Message<GetTopActiveUsersResponse_UserRuntimeInfo> {
  /**
   * User ID.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * User name if available.
   *
   * @generated from field: string user_name = 2;
   */
  userName = "";

  /**
   * User avatar if available.
   *
   * @generated from field: string user_avatar_url = 3;
   */
  userAvatarUrl = "";

  /**
   * Total environment runtime in seconds.
   *
   * @generated from field: double total_runtime_seconds = 4;
   */
  totalRuntimeSeconds = 0;

  constructor(data?: PartialMessage<GetTopActiveUsersResponse_UserRuntimeInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_runtime_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopActiveUsersResponse_UserRuntimeInfo {
    return new GetTopActiveUsersResponse_UserRuntimeInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse_UserRuntimeInfo {
    return new GetTopActiveUsersResponse_UserRuntimeInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse_UserRuntimeInfo {
    return new GetTopActiveUsersResponse_UserRuntimeInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopActiveUsersResponse_UserRuntimeInfo | PlainMessage<GetTopActiveUsersResponse_UserRuntimeInfo> | undefined, b: GetTopActiveUsersResponse_UserRuntimeInfo | PlainMessage<GetTopActiveUsersResponse_UserRuntimeInfo> | undefined): boolean {
    return proto3.util.equals(GetTopActiveUsersResponse_UserRuntimeInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersTimeSeriesRequest
 */
export class GetActiveUsersTimeSeriesRequest extends Message<GetActiveUsersTimeSeriesRequest> {
  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  constructor(data?: PartialMessage<GetActiveUsersTimeSeriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersTimeSeriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersTimeSeriesRequest {
    return new GetActiveUsersTimeSeriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesRequest {
    return new GetActiveUsersTimeSeriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesRequest {
    return new GetActiveUsersTimeSeriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersTimeSeriesRequest | PlainMessage<GetActiveUsersTimeSeriesRequest> | undefined, b: GetActiveUsersTimeSeriesRequest | PlainMessage<GetActiveUsersTimeSeriesRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersTimeSeriesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersTimeSeriesResponse
 */
export class GetActiveUsersTimeSeriesResponse extends Message<GetActiveUsersTimeSeriesResponse> {
  /**
   * Weekly active users time series [WAU]
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint weekly_active_users = 1;
   */
  weeklyActiveUsers: TimeSeriesPoint[] = [];

  /**
   * Weekly active returning users time series [WAU2+]
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint weekly_active_returning_users = 2;
   */
  weeklyActiveReturningUsers: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetActiveUsersTimeSeriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersTimeSeriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "weekly_active_users", kind: "message", T: TimeSeriesPoint, repeated: true },
    { no: 2, name: "weekly_active_returning_users", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersTimeSeriesResponse {
    return new GetActiveUsersTimeSeriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesResponse {
    return new GetActiveUsersTimeSeriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesResponse {
    return new GetActiveUsersTimeSeriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersTimeSeriesResponse | PlainMessage<GetActiveUsersTimeSeriesResponse> | undefined, b: GetActiveUsersTimeSeriesResponse | PlainMessage<GetActiveUsersTimeSeriesResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersTimeSeriesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListEnvironmentUsageRecordsRequest
 */
export class ListEnvironmentUsageRecordsRequest extends Message<ListEnvironmentUsageRecordsRequest> {
  /**
   * Pagination options.
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Filter options.
   *
   * @generated from field: gitpod.v1.ListEnvironmentUsageRecordsRequest.Filter filter = 2;
   */
  filter?: ListEnvironmentUsageRecordsRequest_Filter;

  constructor(data?: PartialMessage<ListEnvironmentUsageRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListEnvironmentUsageRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListEnvironmentUsageRecordsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEnvironmentUsageRecordsRequest {
    return new ListEnvironmentUsageRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEnvironmentUsageRecordsRequest {
    return new ListEnvironmentUsageRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEnvironmentUsageRecordsRequest {
    return new ListEnvironmentUsageRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListEnvironmentUsageRecordsRequest | PlainMessage<ListEnvironmentUsageRecordsRequest> | undefined, b: ListEnvironmentUsageRecordsRequest | PlainMessage<ListEnvironmentUsageRecordsRequest> | undefined): boolean {
    return proto3.util.equals(ListEnvironmentUsageRecordsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListEnvironmentUsageRecordsRequest.Filter
 */
export class ListEnvironmentUsageRecordsRequest_Filter extends Message<ListEnvironmentUsageRecordsRequest_Filter> {
  /**
   * Optional project ID to filter runtime records by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query runtime records within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  constructor(data?: PartialMessage<ListEnvironmentUsageRecordsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListEnvironmentUsageRecordsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEnvironmentUsageRecordsRequest_Filter {
    return new ListEnvironmentUsageRecordsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEnvironmentUsageRecordsRequest_Filter {
    return new ListEnvironmentUsageRecordsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEnvironmentUsageRecordsRequest_Filter {
    return new ListEnvironmentUsageRecordsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListEnvironmentUsageRecordsRequest_Filter | PlainMessage<ListEnvironmentUsageRecordsRequest_Filter> | undefined, b: ListEnvironmentUsageRecordsRequest_Filter | PlainMessage<ListEnvironmentUsageRecordsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListEnvironmentUsageRecordsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListEnvironmentUsageRecordsResponse
 */
export class ListEnvironmentUsageRecordsResponse extends Message<ListEnvironmentUsageRecordsResponse> {
  /**
   * Pagination response.
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * List of environment runtime records.
   *
   * @generated from field: repeated gitpod.v1.EnvironmentUsageRecord records = 2;
   */
  records: EnvironmentUsageRecord[] = [];

  constructor(data?: PartialMessage<ListEnvironmentUsageRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListEnvironmentUsageRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "records", kind: "message", T: EnvironmentUsageRecord, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEnvironmentUsageRecordsResponse {
    return new ListEnvironmentUsageRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEnvironmentUsageRecordsResponse {
    return new ListEnvironmentUsageRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEnvironmentUsageRecordsResponse {
    return new ListEnvironmentUsageRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListEnvironmentUsageRecordsResponse | PlainMessage<ListEnvironmentUsageRecordsResponse> | undefined, b: ListEnvironmentUsageRecordsResponse | PlainMessage<ListEnvironmentUsageRecordsResponse> | undefined): boolean {
    return proto3.util.equals(ListEnvironmentUsageRecordsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsCountRequest
 */
export class GetActiveEnvironmentsCountRequest extends Message<GetActiveEnvironmentsCountRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetActiveEnvironmentsCountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveEnvironmentsCountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveEnvironmentsCountRequest {
    return new GetActiveEnvironmentsCountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsCountRequest {
    return new GetActiveEnvironmentsCountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsCountRequest {
    return new GetActiveEnvironmentsCountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveEnvironmentsCountRequest | PlainMessage<GetActiveEnvironmentsCountRequest> | undefined, b: GetActiveEnvironmentsCountRequest | PlainMessage<GetActiveEnvironmentsCountRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveEnvironmentsCountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsCountResponse
 */
export class GetActiveEnvironmentsCountResponse extends Message<GetActiveEnvironmentsCountResponse> {
  /**
   * Count of active environments in the date range.
   *
   * @generated from field: int64 count = 1;
   */
  count = protoInt64.zero;

  /**
   * Trend of active environments compared to the previous date_range in %. Calculated as (current - previous) / previous.
   *
   * @generated from field: double trend = 2;
   */
  trend = 0;

  constructor(data?: PartialMessage<GetActiveEnvironmentsCountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveEnvironmentsCountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveEnvironmentsCountResponse {
    return new GetActiveEnvironmentsCountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsCountResponse {
    return new GetActiveEnvironmentsCountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsCountResponse {
    return new GetActiveEnvironmentsCountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveEnvironmentsCountResponse | PlainMessage<GetActiveEnvironmentsCountResponse> | undefined, b: GetActiveEnvironmentsCountResponse | PlainMessage<GetActiveEnvironmentsCountResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveEnvironmentsCountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsTimeSeriesRequest
 */
export class GetActiveEnvironmentsTimeSeriesRequest extends Message<GetActiveEnvironmentsTimeSeriesRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  constructor(data?: PartialMessage<GetActiveEnvironmentsTimeSeriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveEnvironmentsTimeSeriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveEnvironmentsTimeSeriesRequest {
    return new GetActiveEnvironmentsTimeSeriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsTimeSeriesRequest {
    return new GetActiveEnvironmentsTimeSeriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsTimeSeriesRequest {
    return new GetActiveEnvironmentsTimeSeriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveEnvironmentsTimeSeriesRequest | PlainMessage<GetActiveEnvironmentsTimeSeriesRequest> | undefined, b: GetActiveEnvironmentsTimeSeriesRequest | PlainMessage<GetActiveEnvironmentsTimeSeriesRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveEnvironmentsTimeSeriesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsTimeSeriesResponse
 */
export class GetActiveEnvironmentsTimeSeriesResponse extends Message<GetActiveEnvironmentsTimeSeriesResponse> {
  /**
   * Active environments time series
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint active_environments = 1;
   */
  activeEnvironments: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetActiveEnvironmentsTimeSeriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveEnvironmentsTimeSeriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "active_environments", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveEnvironmentsTimeSeriesResponse {
    return new GetActiveEnvironmentsTimeSeriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsTimeSeriesResponse {
    return new GetActiveEnvironmentsTimeSeriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveEnvironmentsTimeSeriesResponse {
    return new GetActiveEnvironmentsTimeSeriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveEnvironmentsTimeSeriesResponse | PlainMessage<GetActiveEnvironmentsTimeSeriesResponse> | undefined, b: GetActiveEnvironmentsTimeSeriesResponse | PlainMessage<GetActiveEnvironmentsTimeSeriesResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveEnvironmentsTimeSeriesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeRequest
 */
export class GetEnvironmentRuntimeRequest extends Message<GetEnvironmentRuntimeRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetEnvironmentRuntimeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnvironmentRuntimeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnvironmentRuntimeRequest {
    return new GetEnvironmentRuntimeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeRequest {
    return new GetEnvironmentRuntimeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeRequest {
    return new GetEnvironmentRuntimeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnvironmentRuntimeRequest | PlainMessage<GetEnvironmentRuntimeRequest> | undefined, b: GetEnvironmentRuntimeRequest | PlainMessage<GetEnvironmentRuntimeRequest> | undefined): boolean {
    return proto3.util.equals(GetEnvironmentRuntimeRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeResponse
 */
export class GetEnvironmentRuntimeResponse extends Message<GetEnvironmentRuntimeResponse> {
  /**
   * Total runtime in seconds.
   *
   * @generated from field: int64 total_runtime_seconds = 1;
   */
  totalRuntimeSeconds = protoInt64.zero;

  /**
   * Trend of total runtime compared to the previous date_range in %. Calculated as (current - previous) / previous.
   *
   * @generated from field: double trend = 2;
   */
  trend = 0;

  constructor(data?: PartialMessage<GetEnvironmentRuntimeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnvironmentRuntimeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_runtime_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnvironmentRuntimeResponse {
    return new GetEnvironmentRuntimeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeResponse {
    return new GetEnvironmentRuntimeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeResponse {
    return new GetEnvironmentRuntimeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnvironmentRuntimeResponse | PlainMessage<GetEnvironmentRuntimeResponse> | undefined, b: GetEnvironmentRuntimeResponse | PlainMessage<GetEnvironmentRuntimeResponse> | undefined): boolean {
    return proto3.util.equals(GetEnvironmentRuntimeResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeTimeSeriesRequest
 */
export class GetEnvironmentRuntimeTimeSeriesRequest extends Message<GetEnvironmentRuntimeTimeSeriesRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  constructor(data?: PartialMessage<GetEnvironmentRuntimeTimeSeriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnvironmentRuntimeTimeSeriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnvironmentRuntimeTimeSeriesRequest {
    return new GetEnvironmentRuntimeTimeSeriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeTimeSeriesRequest {
    return new GetEnvironmentRuntimeTimeSeriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeTimeSeriesRequest {
    return new GetEnvironmentRuntimeTimeSeriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnvironmentRuntimeTimeSeriesRequest | PlainMessage<GetEnvironmentRuntimeTimeSeriesRequest> | undefined, b: GetEnvironmentRuntimeTimeSeriesRequest | PlainMessage<GetEnvironmentRuntimeTimeSeriesRequest> | undefined): boolean {
    return proto3.util.equals(GetEnvironmentRuntimeTimeSeriesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeTimeSeriesResponse
 */
export class GetEnvironmentRuntimeTimeSeriesResponse extends Message<GetEnvironmentRuntimeTimeSeriesResponse> {
  /**
   * Total runtime time series
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint total_runtime = 1;
   */
  totalRuntime: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetEnvironmentRuntimeTimeSeriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnvironmentRuntimeTimeSeriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_runtime", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnvironmentRuntimeTimeSeriesResponse {
    return new GetEnvironmentRuntimeTimeSeriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeTimeSeriesResponse {
    return new GetEnvironmentRuntimeTimeSeriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnvironmentRuntimeTimeSeriesResponse {
    return new GetEnvironmentRuntimeTimeSeriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnvironmentRuntimeTimeSeriesResponse | PlainMessage<GetEnvironmentRuntimeTimeSeriesResponse> | undefined, b: GetEnvironmentRuntimeTimeSeriesResponse | PlainMessage<GetEnvironmentRuntimeTimeSeriesResponse> | undefined): boolean {
    return proto3.util.equals(GetEnvironmentRuntimeTimeSeriesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopProjectsRequest
 */
export class GetTopProjectsRequest extends Message<GetTopProjectsRequest> {
  /**
   * Pagination options.
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  constructor(data?: PartialMessage<GetTopProjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopProjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopProjectsRequest {
    return new GetTopProjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopProjectsRequest {
    return new GetTopProjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopProjectsRequest {
    return new GetTopProjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopProjectsRequest | PlainMessage<GetTopProjectsRequest> | undefined, b: GetTopProjectsRequest | PlainMessage<GetTopProjectsRequest> | undefined): boolean {
    return proto3.util.equals(GetTopProjectsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopProjectsResponse
 */
export class GetTopProjectsResponse extends Message<GetTopProjectsResponse> {
  /**
   * List of projects sorted by total runtime (descending).
   *
   * @generated from field: repeated gitpod.v1.GetTopProjectsResponse.ProjectRuntimeInfo projects = 1;
   */
  projects: GetTopProjectsResponse_ProjectRuntimeInfo[] = [];

  /**
   * Pagination response.
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  constructor(data?: PartialMessage<GetTopProjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopProjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "projects", kind: "message", T: GetTopProjectsResponse_ProjectRuntimeInfo, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopProjectsResponse {
    return new GetTopProjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopProjectsResponse {
    return new GetTopProjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopProjectsResponse {
    return new GetTopProjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopProjectsResponse | PlainMessage<GetTopProjectsResponse> | undefined, b: GetTopProjectsResponse | PlainMessage<GetTopProjectsResponse> | undefined): boolean {
    return proto3.util.equals(GetTopProjectsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopProjectsResponse.ProjectRuntimeInfo
 */
export class GetTopProjectsResponse_ProjectRuntimeInfo extends Message<GetTopProjectsResponse_ProjectRuntimeInfo> {
  /**
   * Project ID.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Project name if available.
   *
   * @generated from field: string project_name = 2;
   */
  projectName = "";

  /**
   * Total runtime in seconds.
   *
   * @generated from field: int64 total_runtime_seconds = 3;
   */
  totalRuntimeSeconds = protoInt64.zero;

  constructor(data?: PartialMessage<GetTopProjectsResponse_ProjectRuntimeInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopProjectsResponse.ProjectRuntimeInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_runtime_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopProjectsResponse_ProjectRuntimeInfo {
    return new GetTopProjectsResponse_ProjectRuntimeInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopProjectsResponse_ProjectRuntimeInfo {
    return new GetTopProjectsResponse_ProjectRuntimeInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopProjectsResponse_ProjectRuntimeInfo {
    return new GetTopProjectsResponse_ProjectRuntimeInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopProjectsResponse_ProjectRuntimeInfo | PlainMessage<GetTopProjectsResponse_ProjectRuntimeInfo> | undefined, b: GetTopProjectsResponse_ProjectRuntimeInfo | PlainMessage<GetTopProjectsResponse_ProjectRuntimeInfo> | undefined): boolean {
    return proto3.util.equals(GetTopProjectsResponse_ProjectRuntimeInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopEnvironmentClassesRequest
 */
export class GetTopEnvironmentClassesRequest extends Message<GetTopEnvironmentClassesRequest> {
  /**
   * Pagination options.
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 3;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetTopEnvironmentClassesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopEnvironmentClassesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopEnvironmentClassesRequest {
    return new GetTopEnvironmentClassesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopEnvironmentClassesRequest {
    return new GetTopEnvironmentClassesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopEnvironmentClassesRequest {
    return new GetTopEnvironmentClassesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopEnvironmentClassesRequest | PlainMessage<GetTopEnvironmentClassesRequest> | undefined, b: GetTopEnvironmentClassesRequest | PlainMessage<GetTopEnvironmentClassesRequest> | undefined): boolean {
    return proto3.util.equals(GetTopEnvironmentClassesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopEnvironmentClassesResponse
 */
export class GetTopEnvironmentClassesResponse extends Message<GetTopEnvironmentClassesResponse> {
  /**
   * List of environment classes sorted by total runtime (descending). All environment classes belonging to local runners are grouped together.
   *
   * @generated from field: repeated gitpod.v1.GetTopEnvironmentClassesResponse.EnvironmentClassRuntimeInfo environment_classes = 1;
   */
  environmentClasses: GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo[] = [];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  constructor(data?: PartialMessage<GetTopEnvironmentClassesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopEnvironmentClassesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_classes", kind: "message", T: GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopEnvironmentClassesResponse {
    return new GetTopEnvironmentClassesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopEnvironmentClassesResponse {
    return new GetTopEnvironmentClassesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopEnvironmentClassesResponse {
    return new GetTopEnvironmentClassesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopEnvironmentClassesResponse | PlainMessage<GetTopEnvironmentClassesResponse> | undefined, b: GetTopEnvironmentClassesResponse | PlainMessage<GetTopEnvironmentClassesResponse> | undefined): boolean {
    return proto3.util.equals(GetTopEnvironmentClassesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopEnvironmentClassesResponse.EnvironmentClassRuntimeInfo
 */
export class GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo extends Message<GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo> {
  /**
   * Environment class ID. Not set for local runners.
   *
   * @generated from field: string environment_class_id = 1;
   */
  environmentClassId = "";

  /**
   * Type of runner that created the environment class.
   *
   * @generated from field: gitpod.v1.RunnerKind runner_kind = 2;
   */
  runnerKind = RunnerKind.UNSPECIFIED;

  /**
   * Name of the runner that created the environment class.
   *
   * @generated from field: string runner_name = 3;
   */
  runnerName = "";

  /**
   * Environment class name if available.
   *
   * @generated from field: string environment_class_name = 4;
   */
  environmentClassName = "";

  /**
   * Total runtime in seconds.
   *
   * @generated from field: int64 total_runtime_seconds = 5;
   */
  totalRuntimeSeconds = protoInt64.zero;

  constructor(data?: PartialMessage<GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopEnvironmentClassesResponse.EnvironmentClassRuntimeInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "runner_kind", kind: "enum", T: proto3.getEnumType(RunnerKind) },
    { no: 3, name: "runner_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "environment_class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "total_runtime_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo {
    return new GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo {
    return new GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo {
    return new GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo | PlainMessage<GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo> | undefined, b: GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo | PlainMessage<GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo> | undefined): boolean {
    return proto3.util.equals(GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAdoptionUsageSummaryRequest
 */
export class GetAdoptionUsageSummaryRequest extends Message<GetAdoptionUsageSummaryRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * Optional user ID to filter metrics for a specific user (personal insights view).
   *
   * @generated from field: string user_id = 3;
   */
  userId = "";

  constructor(data?: PartialMessage<GetAdoptionUsageSummaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAdoptionUsageSummaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdoptionUsageSummaryRequest {
    return new GetAdoptionUsageSummaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdoptionUsageSummaryRequest {
    return new GetAdoptionUsageSummaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdoptionUsageSummaryRequest {
    return new GetAdoptionUsageSummaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdoptionUsageSummaryRequest | PlainMessage<GetAdoptionUsageSummaryRequest> | undefined, b: GetAdoptionUsageSummaryRequest | PlainMessage<GetAdoptionUsageSummaryRequest> | undefined): boolean {
    return proto3.util.equals(GetAdoptionUsageSummaryRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAdoptionUsageSummaryResponse
 */
export class GetAdoptionUsageSummaryResponse extends Message<GetAdoptionUsageSummaryResponse> {
  /**
   * Average environment runtime in seconds per active user.
   *
   * @generated from field: double env_runtime_per_user_seconds = 1;
   */
  envRuntimePerUserSeconds = 0;

  /**
   * Trend of average runtime per user compared to the previous date_range in %.
   * Calculated as (current - previous) / previous.
   *
   * @generated from field: double env_runtime_per_user_trend = 2;
   */
  envRuntimePerUserTrend = 0;

  /**
   * Count of active users in the date range.
   *
   * @generated from field: int64 active_users_count = 3;
   */
  activeUsersCount = protoInt64.zero;

  /**
   * Trend of active users compared to the previous date_range in %.
   *
   * @generated from field: double active_users_trend = 4;
   */
  activeUsersTrend = 0;

  /**
   * Count of power users in the date range.
   *
   * @generated from field: int64 power_users_count = 5;
   */
  powerUsersCount = protoInt64.zero;

  /**
   * Trend of power users compared to the previous date_range in %.
   *
   * @generated from field: double power_users_trend = 6;
   */
  powerUsersTrend = 0;

  /**
   * Threshold in seconds used to determine power users.
   * Displayed to users so they understand the definition.
   *
   * @generated from field: int64 power_users_threshold_seconds = 7;
   */
  powerUsersThresholdSeconds = protoInt64.zero;

  /**
   * Count of environment sessions (total starts) in the date range.
   *
   * @generated from field: int64 sessions_count = 8;
   */
  sessionsCount = protoInt64.zero;

  /**
   * Trend of environment sessions compared to the previous date_range in %.
   *
   * @generated from field: double sessions_trend = 9;
   */
  sessionsTrend = 0;

  /**
   * Sparkline data for the card's trend line (typically ~4 weekly points).
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sparkline = 10;
   */
  sparkline: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetAdoptionUsageSummaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAdoptionUsageSummaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "env_runtime_per_user_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "env_runtime_per_user_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "active_users_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "active_users_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "power_users_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "power_users_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "power_users_threshold_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "sessions_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "sessions_trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "sparkline", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdoptionUsageSummaryResponse {
    return new GetAdoptionUsageSummaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdoptionUsageSummaryResponse {
    return new GetAdoptionUsageSummaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdoptionUsageSummaryResponse {
    return new GetAdoptionUsageSummaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdoptionUsageSummaryResponse | PlainMessage<GetAdoptionUsageSummaryResponse> | undefined, b: GetAdoptionUsageSummaryResponse | PlainMessage<GetAdoptionUsageSummaryResponse> | undefined): boolean {
    return proto3.util.equals(GetAdoptionUsageSummaryResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnvironmentSessionsTimeSeriesRequest
 */
export class GetEnvironmentSessionsTimeSeriesRequest extends Message<GetEnvironmentSessionsTimeSeriesRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  constructor(data?: PartialMessage<GetEnvironmentSessionsTimeSeriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnvironmentSessionsTimeSeriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnvironmentSessionsTimeSeriesRequest {
    return new GetEnvironmentSessionsTimeSeriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnvironmentSessionsTimeSeriesRequest {
    return new GetEnvironmentSessionsTimeSeriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnvironmentSessionsTimeSeriesRequest {
    return new GetEnvironmentSessionsTimeSeriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnvironmentSessionsTimeSeriesRequest | PlainMessage<GetEnvironmentSessionsTimeSeriesRequest> | undefined, b: GetEnvironmentSessionsTimeSeriesRequest | PlainMessage<GetEnvironmentSessionsTimeSeriesRequest> | undefined): boolean {
    return proto3.util.equals(GetEnvironmentSessionsTimeSeriesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnvironmentSessionsTimeSeriesResponse
 */
export class GetEnvironmentSessionsTimeSeriesResponse extends Message<GetEnvironmentSessionsTimeSeriesResponse> {
  /**
   * Environment sessions time series. Counts total environment starts per time bucket,
   * as opposed to GetActiveEnvironmentsTimeSeries which counts distinct environment IDs.
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sessions = 1;
   */
  sessions: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetEnvironmentSessionsTimeSeriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnvironmentSessionsTimeSeriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sessions", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnvironmentSessionsTimeSeriesResponse {
    return new GetEnvironmentSessionsTimeSeriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnvironmentSessionsTimeSeriesResponse {
    return new GetEnvironmentSessionsTimeSeriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnvironmentSessionsTimeSeriesResponse {
    return new GetEnvironmentSessionsTimeSeriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnvironmentSessionsTimeSeriesResponse | PlainMessage<GetEnvironmentSessionsTimeSeriesResponse> | undefined, b: GetEnvironmentSessionsTimeSeriesResponse | PlainMessage<GetEnvironmentSessionsTimeSeriesResponse> | undefined): boolean {
    return proto3.util.equals(GetEnvironmentSessionsTimeSeriesResponse, a, b);
  }
}

